import { Box, Flex, FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { useContext, useEffect } from "react";

import { RanaSelect, RanaSelectProps } from "../../rana-select";
import { useFormFieldError } from "../hooks/use-rana-form-field-error";
import { RanaFormContext } from "../rana-form";

export interface RanaFormDropdownProps extends Omit<RanaSelectProps, "onChange" | "value"> {
  field: string;
  isRequired?: boolean;
  label?: string;
}

export function RanaFormDropdown({ field, label, isRequired, ...rest }: RanaFormDropdownProps) {
  const { setPartialValues, values, addRequired } = useContext(RanaFormContext);

  const error = useFormFieldError(field);
  const value = values[field];
  useEffect(() => {
    if (isRequired) addRequired(field);
  }, [addRequired, field, isRequired]);

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <Flex direction="column" position="relative">
        <FormLabel>{label}</FormLabel>

        <Box>
          <RanaSelect
            mb={6}
            w="full"
            value={value + ""}
            onChange={(value) => {
              setPartialValues({ [field]: value });
            }}
            {...rest}
          />
        </Box>

        <FormErrorMessage>{error}</FormErrorMessage>
      </Flex>
    </FormControl>
  );
}
